var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('account-head'),_c('div',{staticClass:"application-main"},[_c('login')],1),_c('account-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }